import { render, staticRenderFns } from "./qr-setting.vue?vue&type=template&id=ef081c38"
import script from "./qr-setting.vue?vue&type=script&lang=js"
export * from "./qr-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports